import { QuestionIcon, Button } from "@stacklet/ui";
import { useLocation } from "react-router";

import { useAnalytics } from "app/contexts";
import { useToggleSearchParam } from "app/hooks/routing/useToggleSearchParam";

export function HelpDrawerTrigger() {
  const analytics = useAnalytics();
  const location = useLocation();
  const [isHelpOpen, toggleHelp] = useToggleSearchParam("help");

  function handlePress() {
    if (!isHelpOpen) {
      analytics.track("Help Opened", { path: location.pathname });
    }
    toggleHelp();
  }

  return (
    <Button
      IconLeft={<QuestionIcon size={20} />}
      aria-expanded={isHelpOpen}
      onPress={handlePress}
      variant="tertiary"
    >
      Show Help
    </Button>
  );
}
